import React, { Fragment } from 'react';
import { createIllustration } from '@balance-web/illustration';

export const NotFoundLogoIllustration = createIllustration(
  {
    name: 'NotFoundLogo',
    description: 'Not found logo',
    height: 20,
    width: 20,
  },
  <Fragment>
    <path
      clipRule="evenodd"
      d="M101.558 16.998c0 5.243-4.258 9.494-9.509 9.494-5.252 0-9.509-4.25-9.509-9.494s4.257-9.495 9.51-9.495c5.25 0 9.508 4.25 9.508 9.495ZM377 17a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      fill="#F3F3F4"
      fillRule="evenodd"
    />
    <mask
      height={20}
      id="a"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      width={20}
      x={0}
      y={101}
    >
      <path
        clipRule="evenodd"
        d="M.17 101.493h19.018v18.989H.17v-18.989Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </mask>
    <g mask="url(#a)">
      <path
        clipRule="evenodd"
        d="M19.188 110.987c0 5.244-4.258 9.495-9.51 9.495-5.25 0-9.508-4.251-9.508-9.495 0-5.243 4.257-9.494 9.509-9.494 5.251 0 9.509 4.251 9.509 9.494Z"
        fill="#F3F3F4"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M177.781 173.53c0 .454-.031.901-.094 1.338-.596 4.229-3.985 7.564-8.247 8.086a9.77 9.77 0 0 1-1.168.07c-5.252 0-9.508-4.25-9.508-9.494 0-2.219.759-4.258 2.034-5.873a9.504 9.504 0 0 1 7.443-3.621h.031c5.253 0 9.509 4.249 9.509 9.494Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M177.687 174.868c-.596 4.228-3.985 7.564-8.247 8.086a6.59 6.59 0 0 1-.226-1.72c0-3.657 2.971-6.626 6.637-6.626a6.58 6.58 0 0 1 1.836.26Zm-9.415-10.313c0 .766-.197 1.488-.543 2.115a4.402 4.402 0 0 1-1.894 1.805 4.39 4.39 0 0 1-5.037-.818 9.504 9.504 0 0 1 7.443-3.621c.021.168.031.342.031.519Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M169.215 168.347c0 .934-.758 1.69-1.693 1.69a1.691 1.691 0 1 1 0-3.38c.935 0 1.693.757 1.693 1.69Zm29.289-59.437a5.902 5.902 0 0 1-7.67 3.276 5.887 5.887 0 0 1-3.281-7.659 5.902 5.902 0 0 1 7.67-3.276 5.887 5.887 0 0 1 3.281 7.659Zm-96.658-10.668c-1.359 0-2.46 3.337-2.46 7.454 0-4.117-1.102-7.454-2.461-7.454 1.359 0 2.46-3.337 2.46-7.454 0 4.117 1.102 7.454 2.461 7.454Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M57.465 114.207a1.774 1.774 0 0 1-3.55 0c0-.979.795-1.772 1.775-1.772.98 0 1.775.793 1.775 1.772Zm80.208-4.096a1.774 1.774 0 0 1-3.549 0 1.774 1.774 0 0 1 3.549 0Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M350.011 34.142c0 .979-.794 1.772-1.774 1.772a1.773 1.773 0 1 1 1.774-1.772Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M258.011 58.447c0 .979-.795 1.772-1.775 1.772a1.773 1.773 0 1 1 0-3.543c.98 0 1.775.793 1.775 1.771Z"
      fill="#F3F3F4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M174.027 8.925c-1.626 0-2.946 3.996-2.946 8.924 0-4.928-1.318-8.924-2.946-8.924 1.628 0 2.946-3.997 2.946-8.925 0 4.928 1.32 8.925 2.946 8.925Z"
      fill="#F0F0F1"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M267.289 117.517c-1.969 0-3.565 4.835-3.565 10.798 0-5.963-1.596-10.798-3.565-10.798 1.969 0 3.565-4.836 3.565-10.799 0 5.963 1.596 10.799 3.565 10.799Z"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M126.656 138.242c-1.809 0-3.277 4.445-3.277 9.928 0-5.483-1.467-9.928-3.277-9.928 1.81 0 3.277-4.445 3.277-9.927 0 5.482 1.468 9.927 3.277 9.927Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M371.589 85.465c-1.543 0-2.795 3.79-2.795 8.466 0-4.675-1.251-8.466-2.794-8.466 1.543 0 2.794-3.79 2.794-8.465 0 4.675 1.252 8.465 2.795 8.465Z"
      fill="#F0F0F1"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M209.257 144.297a1.517 1.517 0 0 1-3.036 0 1.517 1.517 0 0 1 3.036 0Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M189.289 38.435a2.149 2.149 0 0 1-2.15 2.147 2.149 2.149 0 0 1-2.15-2.147c0-1.185.963-2.146 2.15-2.146 1.187 0 2.15.961 2.15 2.146Zm21.999-27.41a3.886 3.886 0 0 1-3.89 3.884 3.886 3.886 0 0 1-3.889-3.884 3.886 3.886 0 0 1 3.889-3.883 3.886 3.886 0 0 1 3.89 3.883Z"
      fill="#F3F3F4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M313.092 145.813a1.958 1.958 0 0 1-3.917 0 1.958 1.958 0 0 1 3.917 0Zm-224.456-4.262c0 .68-.551 1.23-1.232 1.23a1.23 1.23 0 1 1 1.232-1.23ZM221.05 64.539a1.231 1.231 0 0 1-2.463 0 1.231 1.231 0 0 1 2.463 0Z"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M167.179 77.638a1.23 1.23 0 1 1-2.465-.001 1.23 1.23 0 0 1 2.465.001Zm-48.622 0a1.231 1.231 0 0 1-2.464 0 1.231 1.231 0 0 1 2.464 0Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <mask
      height={64}
      id="b"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      width={63}
      x={5}
      y={9}
    >
      <path
        clipRule="evenodd"
        d="M5 9.825h62.403v62.309H5V9.823Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </mask>
    <g mask="url(#b)">
      <path
        clipRule="evenodd"
        d="M32.232 71.877c17.09 2.189 32.722-9.87 34.914-26.935C69.338 27.878 57.26 12.27 40.17 10.081 23.081 7.892 7.45 19.95 5.257 37.015 3.065 54.08 15.142 69.688 32.232 71.877Z"
        fill="#F8F9F9"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M32.232 71.878c17.09 2.189 32.722-9.871 34.914-26.935.613-4.771.11-9.43-1.305-13.711-1.017 1.672-3.032 3.257-6.836 1.164-6.491-3.57-7.817 6.424-2.555 9.927 2.969 1.977 5.59 5.598 1.92 8.235-4.03 2.898-10.939-9.86-17.332-5.172-8.585 6.297 6.47 15.757.725 18.582-3.591 1.765-6.166-3.187-6.166-3.187s-7.848 7.297-14.956 1.211c-2.365-2.024-5.641-2.26-7.365.117a31.09 31.09 0 0 0 18.956 9.769Zm320.609-28.141c-2.933 17.03-19.136 28.463-36.192 25.535-17.056-2.928-28.506-19.107-25.574-36.138 2.933-17.03 19.136-28.463 36.192-25.535 17.056 2.928 28.506 19.107 25.574 36.138Z"
      fill="#F0F0F1"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M353.29 37.707c-6.726 1.33-23.43 3.62-36.535-2.968-12.3-6.186-13.527-12.178-19.463-15.61a30.876 30.876 0 0 1 3.219-3.504c6.225.3 16.519 2.058 26.906 9.333 8.819 6.179 18.296 7.348 25.225 7.093a31.03 31.03 0 0 1 .648 5.656Zm-41.27 2.351c-.46.182-8.982 3.431-21.403-1.44a31.527 31.527 0 0 1 2.168-11.621c4.425 4.76 14.491 14.788 19.235 13.06Zm39.179 9.639a31.03 31.03 0 0 1-5.331 8.969c-7.826-2.894-22.683-7.399-33.829-4.85-6.256 1.43-12.023 1.524-16.71 1.112a31.241 31.241 0 0 1-3.558-8.072c6.718-.09 19.52-.675 30.187-3.555 10.946-2.955 21.513 3.45 29.241 6.396Zm-10.695 13.96a31.341 31.341 0 0 1-4.313 2.655c-7.712-3.094-17.584-6.436-22.912-5.5.659-.141 11.755-2.37 27.225 2.845Zm10.014-38.107c-6.003-.407-18.385-2.377-28.374-11.338-5.501-4.932 4.432-3.965 18.319-1.034a31.457 31.457 0 0 1 10.055 12.373Zm-25.034 43.984c-2.873.323-5.84.253-8.835-.262a31.185 31.185 0 0 1-17.032-8.897c5.427.35 16.337 1.987 25.867 9.159ZM315.195 13.22c-.996-.091-5.052-.548-8.164-2.294a31.337 31.337 0 0 1 5.05-2.19c1.132 2.164 2.372 4.216 3.114 4.483Z"
      fill="#F8F9F9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M315.425 13.237a.396.396 0 0 1-.226-.018l.226.018Z"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      d="M361.292 38.847c13.554 4.354 21.923 8.896 21.341 12.278-1.021 5.93-29.184 6.046-62.904.258s-60.227-15.288-59.206-21.219c.598-3.474 10.51-4.953 25.397-4.418"
      stroke="#F0F0F1"
      strokeLinecap="round"
      strokeWidth={6}
    />
    <mask
      height={2}
      id="c"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      width={325}
      x={22}
      y={248}
    >
      <path
        clipRule="evenodd"
        d="M22.128 248.778h324.188V250H22.128v-1.222Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </mask>
    <g mask="url(#c)">
      <path
        clipRule="evenodd"
        d="M346.188 249.389c0 .338-72.572.611-162.094.611C94.572 250 22 249.727 22 249.389c0-.337 72.572-.611 162.094-.611 89.522 0 162.094.274 162.094.611Z"
        fill="#DDD"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M216.489 159.671c4.407-7.679 6.612-18.287 6.612-31.827 0-13.668-2.177-24.408-6.531-32.218-4.354-7.81-10.618-11.716-18.786-11.716-8.171 0-14.432 3.906-18.786 11.716-4.354 7.81-6.531 18.55-6.531 32.218 0 13.54 2.202 24.148 6.611 31.827 4.407 7.683 10.643 11.521 18.706 11.521 8.063 0 14.296-3.838 18.705-11.521Zm-45.393 30.364c-7.579-5.663-13.412-13.864-17.496-24.603-4.086-10.74-6.127-23.398-6.127-37.979 0-14.708 2.015-27.4 6.047-38.075 4.031-10.673 9.836-18.874 17.415-24.603 7.579-5.727 16.529-8.592 26.849-8.592s19.242 2.865 26.768 8.592c7.523 5.73 13.303 13.93 17.335 24.603 4.031 10.675 6.047 23.367 6.047 38.075 0 14.581-2.044 27.239-6.128 37.979-4.087 10.739-9.892 18.94-17.415 24.603-7.527 5.662-16.395 8.493-26.607 8.493-10.215 0-19.109-2.831-26.688-8.493Z"
      fill="#2438B7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M176.658 198.529h21.433V56.182h-21.433V198.53Z"
      fill="#2438B7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M105.396 142.489V94.455L76.37 142.489h29.026Zm-3.548 22.845H48.957V147.37l53.859-88.258h24.188v83.377h16.609v22.845h-16.609v30.265h-25.156v-30.265Zm208.081-22.845V94.455l-29.026 48.034h29.026Zm-3.548 22.845H253.49V147.37l53.858-88.258h24.189v83.377h16.609v22.845h-16.609v30.265h-25.156v-30.265Z"
      fill="#B5BABD"
      fillRule="evenodd"
    />
    <mask
      height={143}
      id="d"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      width={101}
      x={147}
      y={56}
    >
      <path
        clipRule="evenodd"
        d="M176.657 56.183v4.95a41.692 41.692 0 0 0-5.721 3.643c-7.581 5.727-13.385 13.93-17.417 24.602-4.03 10.676-6.046 23.368-6.046 38.075 0 14.581 2.04 27.239 6.127 37.978 4.084 10.741 9.917 18.941 17.498 24.604a42.219 42.219 0 0 0 5.559 3.52v4.974h21.127c10.211 0 19.079-2.831 26.605-8.494 7.524-5.663 13.33-13.863 17.418-24.604 4.084-10.739 6.126-23.397 6.126-37.978 0-14.707-2.016-27.399-6.046-38.075-4.032-10.671-9.813-18.875-17.336-24.602-7.527-5.728-16.447-8.593-26.767-8.593h-21.127Z"
        fill="#fff"
        fillRule="evenodd"
      />
    </mask>
    <g mask="url(#d)">
      <path
        clipRule="evenodd"
        d="M176.657 56.183v4.95a41.692 41.692 0 0 0-5.721 3.643c-7.581 5.727-13.385 13.93-17.417 24.602-4.03 10.676-6.046 23.368-6.046 38.075 0 14.581 2.04 27.239 6.127 37.978 4.084 10.741 9.917 18.941 17.498 24.604a42.219 42.219 0 0 0 5.559 3.52v4.974h21.127c10.211 0 19.079-2.831 26.605-8.494 7.524-5.663 13.33-13.863 17.418-24.604 4.084-10.739 6.126-23.397 6.126-37.978 0-14.707-2.016-27.399-6.046-38.075-4.032-10.671-9.813-18.875-17.336-24.602-7.527-5.728-16.447-8.593-26.767-8.593h-21.127Z"
        fill="#B5BABD"
        fillRule="evenodd"
      />
    </g>
    <path
      clipRule="evenodd"
      d="M202.329 127.843c0 13.541-2.206 24.15-6.611 31.829-4.409 7.681-10.642 11.52-18.707 11.52-8.062 0-14.298-3.839-18.705-11.52-4.409-7.679-6.61-18.288-6.61-31.829 0-13.666 2.177-24.407 6.529-32.218 4.355-7.809 10.615-11.716 18.786-11.716 8.168 0 14.433 3.907 18.788 11.716 4.352 7.811 6.53 18.552 6.53 32.218Z"
      fill="#828383"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M174.87 93.556c-.947 0-1.715 1.883-1.715 4.204 0-2.321-.767-4.204-1.714-4.204.947 0 1.714-1.881 1.714-4.203 0 2.322.768 4.204 1.715 4.204Zm13.255 8.505c-1.557 0-2.82 3.095-2.82 6.913 0-3.818-1.262-6.913-2.819-6.913 1.557 0 2.819-3.096 2.819-6.914 0 3.819 1.263 6.914 2.82 6.914Zm-17.409 17.459c-1.16 0-2.099 2.304-2.099 5.145 0-2.841-.94-5.145-2.098-5.145 1.158 0 2.098-2.303 2.098-5.144 0 2.841.939 5.144 2.099 5.144Zm25.34.868c-.704 0-1.275 1.399-1.275 3.125 0-1.726-.571-3.125-1.275-3.125.704 0 1.275-1.4 1.275-3.126 0 1.726.571 3.126 1.275 3.126Zm-13.132 30.522c-1.381 0-2.5 2.744-2.5 6.129 0-3.385-1.12-6.129-2.5-6.129 1.38 0 2.5-2.744 2.5-6.129 0 3.385 1.119 6.129 2.5 6.129Zm-20.735-14.872c-1.058 0-1.916 2.102-1.916 4.696 0-2.594-.857-4.696-1.915-4.696 1.058 0 1.915-2.102 1.915-4.695 0 2.593.858 4.695 1.916 4.695Z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M84.624 142.489V94.455l-29.026 48.034h29.026Zm-3.548 22.845H28.185V147.37l53.859-88.258h24.188v83.377h16.609v22.845h-16.609v30.265H81.076v-30.265Zm114.642-5.662c-4.409 7.681-10.642 11.52-18.707 11.52-8.062 0-14.298-3.839-18.705-11.52-4.409-7.679-6.61-18.288-6.61-31.829 0-13.666 2.177-24.407 6.529-32.218 4.355-7.809 10.615-11.716 18.786-11.716 8.168 0 14.433 3.907 18.788 11.716 4.352 7.811 6.53 18.552 6.53 32.218 0 13.541-2.206 24.15-6.611 31.829Zm25.396-70.294c-4.029-10.671-9.81-18.875-17.334-24.603-7.526-5.727-16.449-8.592-26.769-8.592-10.321 0-19.27 2.865-26.848 8.592-7.578 5.728-13.385 13.931-17.414 24.602-2.766 7.32-4.582 15.589-5.45 24.802a141.675 141.675 0 0 0-.599 13.274c0 5.941.338 11.562 1.017 16.867.986 7.709 2.69 14.746 5.112 21.11 4.084 10.742 9.917 18.942 17.496 24.605 7.578 5.663 16.472 8.494 26.686 8.494 10.213 0 19.082-2.831 26.608-8.494 7.523-5.663 13.328-13.863 17.415-24.605 4.084-10.738 6.129-23.396 6.129-37.977 0-14.707-2.017-27.399-6.049-38.076Zm68.043 53.111V94.455l-29.026 48.034h29.026Zm-3.548 22.845h-52.891V147.37l53.859-88.258h24.188v83.377h16.609v22.845h-16.609v30.265h-25.156v-30.265Z"
      fill="#D7DBDE"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M27.549 23.772c0 .978-.794 1.771-1.774 1.771S24 24.75 24 23.772c0-.979.794-1.772 1.775-1.772.98 0 1.774.793 1.774 1.772Z"
      fill="#F0F0F1"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m102.866 242.539 3.128-8.245 6.426 4.052-3.458 7.382-6.096-3.189Z"
      fill="#EF3C86"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m103.233 241.492-2.726 7.837 27.702.06s-4.909-5.406-17.702-6.958l-7.274-.939Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m122.408 152.794-2.91 42.924-18.015 44.057 12.136 1.455 19.875-39.246 8.43-44.692-19.516-4.498Z"
      fill="#131318"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m136.626 107.083 30.214-6.048s1.653.215 2.209 2.156c.555 1.94-.317 3.06-.317 3.06l-31.099 12.754-1.007-11.922Z"
      fill="#FF77CA"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m133.397 115.404 18.798 5.483 4.094-13.189 4.286 1.637-2.784 22.008-26.32-4.303 1.926-11.636Z"
      fill="#FF77CA"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m137.32 106.251-20.259 5.303 24.32 6.03-4.061-11.333Z"
      fill="#FE7A00"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M131.143 81.569s8.386 6.317.607 10.758l-.607-10.758Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M112.817 97.865c-1.111-1.633-7.305-2.353-7.522 2.058-.28 5.688 10.414 5.683 10.414 5.683l1.751 7.704 9.516-1.234-1.843-6.779s9.011-1.753 10.587-3.216c0 0-.981-8.98-4-14.705l-9.052-4.53-11.451 4.088 1.6 10.931Z"
      fill="#FF77CA"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M107.615 96.857s-6.314-.738-1.594-9.395c4.719-8.657 11.593-6.74 11.593-6.74s-.266-7.419 4.339-8.67c6.561-1.781 10.374 8.05 10.374 8.05s1.779-6.411 3.875-6.144c2.096.267 7.207 18.515-21.332 16.817 0 0 3.637 4.417-2.053 7.09 0 0-1.637-1.862-5.202-1.008Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M125.76 101.08c-.371-.832.728-2.112 2.379-2.312 2.447-.296 4.086 1.504 3.23 2.82-.82 1.259-2.434-.021-3.807.232-.746.137-1.52-.107-1.802-.74Z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m125.133 105.296-6.147.361 6.854 2.3-.707-2.661Z"
      fill="#EF3C86"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m129.424 93.043 3.361 4.341-2.395.695-.966-5.036Z"
      fill="#285FD7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m143.93 116.422-6.392-9.563 3.559 10.725 2.833-1.162Zm.297 12.703-1.991-11.143-.453 10.744 2.444.399Z"
      fill="#EF3C86"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M127.419 93.661a1.26 1.26 0 0 1-2.271 1.092 1.258 1.258 0 0 1 .588-1.68 1.262 1.262 0 0 1 1.683.588Zm6.046-1.482a1.26 1.26 0 0 1-2.271 1.092 1.26 1.26 0 0 1 2.271-1.092Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M122.222 154.806s-19.951-29.411-5.161-43.252c3.444-3.224 25.257 4.47 25.257 4.47l-.729 17.312-4.269-.884 8.226 12.892 4.478 11.437s-11.462-2.582-24.269-1.877c-.883.048-3.533-.098-3.533-.098Z"
      fill="#FFC100"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m201.516 167.692-4.852-5.248 5.664-5.86 3.909 6.808-4.721 4.3Z"
      fill="#EF3C86"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m203.193 155.011-23.047-26.678c-3.087-3.342-8.337-3.451-11.561-.24l-23.039 17.251s-3.267 8.962-21.739 9.707c0 0 7.006 16.125 23.253 10.411 7.319-2.575 28.029-20.276 28.029-20.276l23.297 22.559 4.807-12.734Z"
      fill="#2D2D32"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m201.516 167.692 4.721 4.95 5.027-26.796s-3.667 5.064-6.943 13.171l-2.805 8.675Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m137.32 132.452-10.238-2.574 12.647 6.348-2.409-3.774Z"
      fill="#FE7A00"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M161.079 101.378c-.172.2-.382.827-.382.827s-2.456 1.909-4.203 4.915c-1.746 3.006 3.54 4.167 3.54 4.167s1.632.293 2.099-.108c.468-.401 1.044-.204 1.384-.419.339-.216.598-1.348 1.47-1.838.871-.49.28-2.226-.098-2.52-.378-.294-2.68-1.026-2.136-2.852.488-1.637-.757-3.235-1.674-2.172Z"
      fill="#FF77CA"
      fillRule="evenodd"
    />
    <path
      d="m155.327 111.887 1.299-4.338s.001-2.632 4.396-5.288m.81-.394s.383.584 0 2.035c-.384 1.452 1.675 1.988 2.207 2.5.533.511.522 1.211.522 1.211m-4.255 3.016.269-2.361"
      stroke="#EF3C86"
    />
  </Fragment>
);
